import { CustomScene } from '../../../types/types'
import cn from 'classnames'
import { DiamondPendantSelectionLabel } from '../RenderPendantSelectionLabel/DiamondPendantSelectionLabel'
import { RenderPendantSelectionLabel } from '../RenderPendantSelectionLabel/RenderPendantSelectionLabel'
import { formatMoney } from '../../../helpers/formatCentsToDollars'
import { ChevronRight } from '../../../icons/ChevronRight'

export const Summary = ({
  isSceneMenu,
  allScenes,
  numberOfPendantScenes,
  currentScene,
  onClick,
  className = 'px-5'
}: {
  isSceneMenu: boolean
  allScenes: CustomScene[]
  numberOfPendantScenes: number
  currentScene?: number
  onClick: (i: number) => void
  className: string
}) => {
  return (
    <div className={`flex flex-col items-center justify-between w-full ${className}`}>
      {allScenes.map((scene, i) => {
        const isPendantScene = scene?.isPendantScene
        const pendantSceneLabel = `Position ${scene?.workflowPosition} of ${numberOfPendantScenes}`
        const isDiamondSelectionScene = scene?.name.toLowerCase().includes('diamond')
        const price = isDiamondSelectionScene ? scene.variants[1].getPrice() : scene?.variants[0]?.getPrice()
        const currentPendantVariantStepTags = scene.steps.find((step) => step.getTags().includes('pendant-selection'))?.getTags()
        const currentPendantSummaryName = currentPendantVariantStepTags?.find((tag) => tag.includes('summary-name'))?.split(':')[1]
        const isBirthstoneStep = !!currentPendantVariantStepTags?.find((tag) => tag.includes('birthstone-step'))

        return (
          <button
            key={i}
            className={cn(
              'flex flex-row items-center justify-between w-full py-[15px] border-t border-secondary uppercase cursor-pointer',
              isSceneMenu && i === currentScene ? 'bg-transparent' : ''
            )}
            onClick={() => onClick(i)}
          >
            <div className="flex flex-col items-start">
              <p className="text-sm-c uppercase font-calibre">{isPendantScene ? pendantSceneLabel : scene?.name}</p>
              <div className="flex">
                {isDiamondSelectionScene ? (
                  <DiamondPendantSelectionLabel scene={scene} />
                ) : (
                  scene?.variants.map((variant, i) => {
                    if (!variant) return
                    // @ts-expect-error - Spiffy metadata is not typed
                    const metadataVariantName = variant?.variantData?.thumbnail?.metadata.find((metadata) => metadata.key === 'variant_name')?.value

                    return (
                      <RenderPendantSelectionLabel
                        key={i}
                        variantName={variant.getName()}
                        isBirthstoneStep={isBirthstoneStep}
                        currentPendantSummaryName={currentPendantSummaryName}
                        metadataVariantName={metadataVariantName}
                      />
                    )
                  })
                )}
              </div>
            </div>
            <div className="flex justify-between items-center gap-[15px]">
              {price !== 0 && <p className="text-xs font-calibre">{formatMoney(price)}</p>}
              <ChevronRight />
            </div>
          </button>
        )
      })}
    </div>
  )
}
